import { render, staticRenderFns } from "./TransliterationTablePage.vue?vue&type=template&id=19cdca8c&scoped=true&"
import script from "./TransliterationTablePage.vue?vue&type=script&lang=js&"
export * from "./TransliterationTablePage.vue?vue&type=script&lang=js&"
import style0 from "./TransliterationTablePage.vue?vue&type=style&index=0&id=19cdca8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cdca8c",
  null
  
)

export default component.exports